<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Fale Conosco</h2>
            <ul>
                <li><a routerLink="/">Home </a></li>
                <li class="active">Fale Conosco</li>
            </ul>
        </div>
    </div>

    <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div>
</div>

<!--section class="contact-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-sm-6">
                <div class="single-contact">
                    <div class="icon">
                        <i class='bx bx-envelope'></i>
                    </div>

                    <div class="content">
                        <h3>Email</h3>
                        <p>hello@aiva.com</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-contact">
                    <div class="icon">
                        <i class='bx bx-location-plus'></i>
                    </div>

                    <div class="content">
                        <h3>Address</h3>
                        <p>28/A Street, New York City, USA</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-12">
                <div class="single-contact">
                    <div class="icon">
                        <i class='bx bx-phone-call'></i>
                    </div>

                    <div class="content">
                        <h3>Phone</h3>
                        <p>+1 (321) 984 754</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section-->

<section class="home-contact-area home-2-contact pb-100 pt-100">
    <div class="container">
        <div class="section-title">
            <span>Entre em Contato</span>
            <h2>Queremos ouvir você!</h2>
            <p>Se você quer saber mais sobre nosso negócio ou quer ser um profissional parceiro, preencha o
                formulário abaixo ou entre em contato pelo e-mail <a href="mailto: contato@listenonline.com.br">contato@listenonline.com.br</a>.</p>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="content">
                    <form id="contactForm" [formGroup]="contactForm">
                        <div class="row">
                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <input type="text" name="name" id="name" formControlName='name' class="form-control" required placeholder="Seu nome" />
                                </div>
                            </div>

                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <input type="email" name="email" id="email" formControlName='email' class="form-control" required placeholder="Seu e-mail" />
                                </div>
                            </div>

                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <input type="text" name="phone_number" id="phone_number" formControlName='phone_number' required class="form-control" mask='(00) 0000-0000 || (00) 00000-0000' [dropSpecialCharacters]="false" placeholder="Seu telefone" />
                                </div>
                            </div>

                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <input type="text" name="msg_subject" id="msg_subject" formControlName='msg_subject' class="form-control" required placeholder="Assunto" />
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea name="message" class="form-control" id="message" formControlName='message' cols="30" rows="5" required placeholder="Sua mensagem"></textarea>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="default-btn page-btn box-btn" [disabled]='sending' (click)='sendContactForm()'>Enviar</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="contact-img contact-img-2">
                    <img src="assets/images/contact-img2.jpg" alt="contact" />
                </div>
            </div>
        </div>
    </div>
</section>